import config from "@/config/config";
import { authAdapter } from "@/core/auth/adapter";
import { toast } from "@k3-tech/react-kit";
import { authExchange } from "@urql/exchange-auth";
import { throwOnErrorExchange } from "@urql/exchange-throw-on-error";
import { Client, cacheExchange, errorExchange, fetchExchange } from "urql";

// Auth exchange powered by our auth adapter
const adapterAuthExchange = authExchange(async (utils) => {
	return {
		addAuthToOperation(operation) {
			const skipAuth = operation.context?.skipAuth;
			if (skipAuth) {
				return operation;
			}
			const token = authAdapter.getToken();
			if (!token) return operation;
			return utils.appendHeaders(operation, {
				Authorization: `Bearer ${token}`,
			});
		},
		didAuthError(error) {
			return error.response?.status === 401;
		},
		async refreshAuth() {
			await authAdapter.refresh();
		},
	};
});

// biome-ignore lint:
function extractGraphQLErrorMessage(error: any): string {
	return (
		error?.graphQLErrors?.[0]?.extensions?.errors?.[0]?.message ??
		error?.graphQLErrors?.[0]?.message ??
		error?.message ??
		"An unexpected error occurred"
	);
}

export const urqlClient = new Client({
	url: config.BACKEND_ENDPOINT,
	suspense: true,
	exchanges: [
		cacheExchange,
		adapterAuthExchange,
		throwOnErrorExchange(),
		errorExchange({
			onError(error, _operation) {
				// Don't show toast for expired refresh token errors
				const message = extractGraphQLErrorMessage(error);
				const isTokenExpired =
					message.includes("token is expired") ||
					message.includes('exp" not satisfied');
				const nullSchemaError = message.includes(
					"the requested element is null which the schema does not allow",
				);

				if (!isTokenExpired) {
          let finalMsg = message;

          if (nullSchemaError) {
            finalMsg += `: ${error?.graphQLErrors?.[0]?.path?.join('/')}`;
          }

					toast.error("Error", {
						description: finalMsg,
						closeButton: true,
					});
				}

				console.error("GraphQL Error:", message, error);
			},
		}),
		fetchExchange,
	],
});
